import { object } from "@hapi/joi";
import { CommonGet, CommonPost } from "../../../utils/CommonFetch";

export default {
    GetCollectionCategoryByOperationEntityID
};

async function GetCollectionCategoryByOperationEntityID(id) {
    var collectionCategoryArray = [];
    const response = await CommonGet('/api/CollectionCategory/GetCollectionCategoryByOperationEntityID', 'operationEntityID=' + id);
    for (let item of Object.entries(response.data)) {
        if(item[1]["isActive"] === true) {
            collectionCategoryArray[item[1]["collectionCategoryID"]] = item[1]["collectionCategoryName"]
        }
    }
    return collectionCategoryArray;
}

